import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=37af615a&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=37af615a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af615a",
  null
  
)

export default component.exports